module.exports = {
	"classes": [
		"security-page",
		"header-dark"
	],
	"title": "Security",
	"metas": {
		"description": "Policies Regarding Data Security & Confidentiality."
	},
	"opengraph": {
		"og:title": "Security",
		"og:description": "Policies Regarding Data Security & Confidentiality.",
		"og:url": "https://auth0.com/security",
		"og:image": "https://cdn.auth0.com/website/security/twitter-card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/security/twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Security",
		"twitter:description": "Policies Regarding Data Security & Confidentiality.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/security/twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/security/metadata.json
// module id = 1432
// module chunks = 0